module.exports = __webpack_public_path__ + "static/img/11.e629bb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/zh/11.png
// module id = KNJB
// module chunks = 0